<template>
    <div>
        <span
            v-for="sale in product.sales"
            class="product-badges my-position-absolute"
              :class="sale.position"
              style="z-index: 300;">
            <span class="product-badge">
                <img :src="sale.icon" alt="custom-sale">
            </span>
        </span>

        <span class="article-tags flex space-x-1 absolute inset-y-0 right-0">
            <span
                v-if="product.has3DImages"
                class="item-has-3d">
    <!--                <img src="{{ asset('images/3d.png') }}" alt="3d">-->
            </span>

            <span
                v-if="!product.percent && product.hasDiscount"
                class="article-tag article-tag-promo">
                {{ product.discount }}%</span>

            <span
                v-if="product.percent"
                class="article-tag article-tag-promo">
                - {{ product.percent }}%
            </span>

            <span
                v-if="product.isNew"
                class="article-tag">{{ __('Új') }}</span>
        </span>
    </div>
</template>

<script>
export default {
    name: 'Badges',

    props: {
        product: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.product-badges {
    &.top-left {
        top: 0;
        left: 0;
    }

    &.top-right {
        top: 0;
        right: 0;
    }

    &.bottom-left {
        bottom: 0;
        left: 0;
    }

    &.bottom-right {
        bottom: 0;
        right: 0;
    }
}
</style>
